import React, { useState, useEffect } from "react";
import {
  IconButton,
  TextField,
  Button,
  Grid,
  Typography,
  Paper,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginUser, loadUser } from "../../redux/actions/user";
import logo from "../../assets/6-removebg.png";
import { tokens } from "../../theme";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user, isAuthenticated } = useSelector((state) => state.user);

  const handleSignIn = (e) => {
    e.preventDefault();
    dispatch(loginUser(email, password));
  };

  useEffect(() => {
    if (isAuthenticated && user) {
      if (user.role === "superadmin") {
        navigate("/dashboard");
      } else if (user.shop) {
        switch (user.shop.enum) {
          case "electronics":
            navigate("/produit");
            break;
          case "alimentation":
            navigate("/produit-alimentation");
            break;
          default:
            navigate("/dashboard");
        }
      } else {
        navigate("/dashboard");
      }
    }
  }, [isAuthenticated, user, navigate]);

  useEffect(() => {
    dispatch(loadUser());
  }, [dispatch]);

  return (
    <Grid
      container
      sx={{
        height: "100vh",
        background: "linear-gradient(135deg, #265a2e, #595d5a)",
        alignItems: "center",
        justifyContent: "center",
        padding: 2,
      }}
    >
      {/* Left Section */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          textAlign: "center",
          padding: 4,
        }}
      >
        <img
          src={logo}
          alt="Logo"
          width="90px"
          height="90px"
          style={{
            backgroundColor: "white",
            marginBottom: "10px",
          }}
        />
        <Typography
          variant="h3"
          sx={{
            fontWeight: "bold",
            marginBottom: 2,
            textShadow: "2px 2px 5px rgba(0,0,0,0.3)",
          }}
        >
          Welcome Back!
        </Typography>
        <Typography
          sx={{
            fontSize: 18,
            lineHeight: 1.5,
            maxWidth: 400,
            opacity: 0.9,
          }}
        >
          Log in to continue your journey with us and access your account.
        </Typography>
      </Grid>

      {/* Right Section */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper
          elevation={5}
          sx={{
            padding: 4,
            width: "100%",
            maxWidth: 400,
            borderRadius: 5,
            boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.1)",
          }}
        >
          <form onSubmit={handleSignIn}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                marginBottom: 3,
                textAlign: "center",
              }}
            >
              Se Connecter
            </Typography>

            <TextField
              type="email"
              label="Username"
              variant="outlined"
              fullWidth
              margin="normal"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 3,
                },
              }}
            />

            <TextField
              type={showPassword ? "text" : "password"}
              label="Password"
              variant="outlined"
              fullWidth
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              InputProps={{
                endAdornment: (
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                ),
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 3,
                },
              }}
            />

            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{
                marginTop: 2,
                padding: "12px 0",
                background: "linear-gradient(135deg, #265a2e, #595d5a)",
                color: "#fff",
                fontWeight: "bold",
                borderRadius: 3,
                transition: "all 0.3s",
                "&:hover": {
                  background: "linear-gradient(135deg, #595d5a, #265a2e)",
                  transform: "translateY(-2px)",
                },
              }}
            >
              Login
            </Button>
          </form>
        </Paper>
      </Grid>
    </Grid>
  );
}

export default Login;
